import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="pt-20 min-h-screen flex items-center">
      <section className="py-24 px-6 md:px-12 lg:px-24 w-full">
        <div className="max-w-2xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-8xl sm:text-9xl font-black text-emerald/20 font-heading mb-4">
              404
            </p>
            <h1 className="text-4xl sm:text-5xl tracking-tighter font-black text-navy mb-4 font-heading">
              Page Not Found
            </h1>
            <p className="text-base leading-relaxed text-slate-600 mb-10">
              The page you&apos;re looking for doesn&apos;t exist or may have been
              moved. Check the URL or head back to the homepage.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button
                  data-testid="not-found-home-button"
                  size="lg"
                  className="bg-emerald hover:bg-emerald-light text-white font-semibold w-full sm:w-auto"
                >
                  <Home className="mr-2 h-5 w-5" />
                  Back to Home
                </Button>
              </Link>
              <Button
                data-testid="not-found-back-button"
                variant="outline"
                size="lg"
                className="border-2 border-navy text-navy hover:bg-slate-50 font-semibold w-full sm:w-auto"
                onClick={() => window.history.back()}
              >
                <ArrowLeft className="mr-2 h-5 w-5" />
                Go Back
              </Button>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
